const WiskeyMass=[

    
    {
        id:15,
        title:"Ardbeg Ten, 10 уо (Шотландія) 0,7л",
        price:"5600 грн",
        src:require('../img/ardbeg.png'),
        text:"50мл - 400 грн",
    },
   
    {
        id:1,
        title:"Гленморанджі Оріджинал, 10 уо (Шотландія) 1л",
        price:"6000 грн",
        src: require('../img/glen.webp'),
        text:"50мл - 300 грн",
    },
    {
        id:2,
        title:"Macallan 12Y.O Double Cask (Шотландія) 1л",
        price:"8400 грн",
        src: require('../img/macalan.png'),
        text:"50мл - 420 грн",
    },
    // {
    //     id:3,
    //     title:"Віскі чівас 12 років (Шотландія) 1л",
    //     price:"4200 грн",
    //     src: require('../img/chivas.png'),
    //     text:"50мл - 210 грн",
    // },
    {
        id:4,
        title:"Белл'с Оріджинал (Шотландія) 1л",
        price:"1800 грн",
        src: require('../img/bels.webp'),
        text:"50мл - 90 грн",
    },
    {
        id:5,
        title:"Белл'с Оріджинал (Шотландія) 0,5л",
        price:"1000 грн",
        src: require('../img/bels.webp'),
        text:"",
    },
    // {
    //     id:6,
    //     title:"Бушміллс Оріджинал (Ірландія) 1л",
    //     price:"1960 грн",
    //     src: require('../img/bush.webp'),
    //     text:"50мл - 98 грн",
    // },
    // {
    //     id:7,
    //     title:"Джек Деніелс (Теннессі) 1л",
    //     price:"2160 грн",
    //     src: require('../img/jd.webp'),
    //     text:"50мл - 108 грн",
    // },
    {
        id:8,
        title:"Джек Деніелс Медовий (Теннессі) 1л",
        price:"3200 грн",
        src: require('../img/jdh.webp'),
        text:"50мл - 160 грн",
    },
    {
        id:9,
        title:"Джек Деніелс Медовий (Теннессі) 0,5л",
        price:"1700 грн",
        src: require('../img/jdh.webp'),
        text:"",
    },
    {
        id:10,
        title:"Сінглтон оф Даффтаун 12 YO (Шотландія) 1л",
        price:"4700 грн",
        src:require('../img/singlton.png'),
        text:"50мл - 235 грн",
    },
    {
        id:11,
        title:"Джонні Уокер Ред Лейбл (Шотландія) 1л",
        price:"2800 грн",
        src:require('../img/label.png'),
        text:"50мл - 140 грн",
    },
    {
        id:12,
        title:"Джонні Уокер Блек Лейбл (Шотландія) 1л",
        price:"3800 грн",
        src:require('../img/blacklabel.png'),
        text:"50мл - 190 грн",
    },
    {
        id:13,
        title:"Бурбон Буліт (США) 0,7л",
        price:"2450 грн",
        src:require('../img/bulit.png'),
        text:"50мл - 175 грн",
    },
    {
        id:14,
        title:"О'Браєн (Ірландія) 0,7л",
        price:"1890 грн",
        src:require('../img/obrayen.png'),
        text:"50мл - 135 грн",
    },
    
]

export default WiskeyMass;